/**
 * TICKET P5-C §3 (Schnellanlage einer Mietereinheit): reine Helfer für den
 * Schnellanlage-Dialog. Hier liegen zwei testbare Funktionen ohne React:
 *  - `deriveUnitLabel` baut aus Stockwerk/Lage/Mieter/Vertragsnummer die
 *    pflichtige `label` der Einheit (die DTO verlangt `label`, der Dialog fragt
 *    aber bewusst nur Vertragsnummer + Name als Minimum ab).
 *  - `looksLikeLeaseNumber` erkennt in der globalen Suche eine gesuchte
 *    Mietvertragsnummer, damit ein Fehltreffer die Schnellanlage anbieten kann.
 */

export interface UnitLabelParts {
  tenantName?: string | null;
  floor?: string | null;
  position?: string | null;
  leaseNumber?: string | null;
}

/**
 * Leitet die (pflichtige) Einheiten-Bezeichnung aus den Schnellanlage-Feldern
 * ab: bevorzugt „Stockwerk Lage · Mieter", fällt sonst auf einzelne Teile und
 * zuletzt auf die Vertragsnummer zurück. Nie leer.
 */
export function deriveUnitLabel(parts: UnitLabelParts): string {
  const loc = [parts.floor, parts.position]
    .map((s) => (s ?? '').trim())
    .filter(Boolean)
    .join(' ');
  const name = (parts.tenantName ?? '').trim();
  const lease = (parts.leaseNumber ?? '').trim();
  if (loc && name) return `${loc} · ${name}`;
  return loc || name || lease || 'Einheit';
}

/**
 * Heuristik für die Suche-Fehltreffer-CTA: sieht die Eingabe nach einer
 * Mietvertragsnummer aus? Trifft rein numerische Nummern ab vier Stellen
 * (z. B. „72107") und segmentierte Nummern mit Punkt (z. B. „72107.0011",
 * „72107.0009.03"). Führende/abschließende Leerzeichen sind toleriert.
 */
export function looksLikeLeaseNumber(query: string): boolean {
  const q = query.trim();
  if (q.length === 0) return false;
  // Mindestens vier führende Ziffern …
  if (/^\d{4,}/.test(q)) return true;
  // … oder ein Punkt-Segment-Muster wie 72107.0011 / 12.34.
  if (/^\d+\.\d+/.test(q)) return true;
  return false;
}
